import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '@fluentui/react-components';
import { useAuth } from './AuthContext';

/**
 * Gate for the authenticated part of the app. While the initial silent refresh
 * is running we render a spinner rather than bouncing to /login, so a page
 * reload with a valid refresh cookie does not flash the sign-in form.
 */
const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated, initializing } = useAuth();
    const location = useLocation();

    if (initializing) {
        return (
            <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
                <Spinner label="Проверяем сессию..." />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return <>{children}</>;
};

export default RequireAuth;
